import { SvgIcon, SvgIconProps } from "@mui/material";

const DiagramProject = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 15 14" {...props}>
      <path d="M0 1.94401C0 1.29967 0.522326 0.777344 1.16667 0.777344H3.5C4.1441 0.777344 4.66667 1.29967 4.66667 1.94401V4.27734C4.66667 4.92144 4.1441 5.44401 3.5 5.44401H1.16667C0.522326 5.44401 0 4.92144 0 4.27734V1.94401ZM5.44444 8.16623C5.44444 7.52214 5.96701 6.99957 6.61111 6.99957H8.94444C9.58854 6.99957 10.1111 7.52214 10.1111 8.16623V10.4996C10.1111 11.1437 9.58854 11.6662 8.94444 11.6662H6.61111C5.96701 11.6662 5.44444 11.1437 5.44444 10.4996V8.16623ZM12.8333 0.777344C13.4774 0.777344 14 1.29967 14 1.94401V4.27734C14 4.92144 13.4774 5.44401 12.8333 5.44401H10.5C9.8559 5.44401 9.33333 4.92144 9.33333 4.27734V1.94401C9.33333 1.29967 9.8559 0.777344 10.5 0.777344H12.8333Z" />
      <path
        className="secondary"
        d="M4.65937 4.37711L6.61111 6.99967C6.00833 6.99967 5.5125 7.45662 5.45174 8.04481L3.5 5.44412C4.10278 5.44412 4.59861 4.98717 4.65937 4.37711ZM4.66667 2.33301H9.33333V3.88856H4.66667V2.33301Z"
      />
    </SvgIcon>
  );
};

export default DiagramProject;
